import Axios, { AxiosResponse } from 'axios';
import { IFileActionDispatchPayload } from 'redux/file/types';
import APIService from 'services/apiUtils';

import { IGetDocument, IUploadDocument } from '../../redux/file/types';
import { emitUploadFileEvent } from '../../utils/realtimeUpdate';
import ApiEndpoint from './apiEndpoint';

export default class FileService {
  // FIXME remove proxy server to when cors fixed
  static uploadFile(reqBody: IFileActionDispatchPayload): Promise<AxiosResponse<any>[]> {
    const { files, thumbnails, urls, thumbnailUrls, fileTypes } = reqBody;
    let apiCalls = files.map((f, i: number) =>
      Axios.put(urls[i], f, {
        headers: {
          'x-amz-acl': 'public-read',
          'Content-Type': fileTypes[i],
        },
      }),
    );

    apiCalls = [
      ...apiCalls,
      ...thumbnails.map((f, i: number) =>
        Axios.put(thumbnailUrls[i], f, {
          headers: {
            'x-amz-acl': 'public-read',
            'Content-Type': f.type,
          },
        }),
      ),
    ];

    return Promise.all(apiCalls);
  }

  static uploadTransactionDocument(reqBody: IUploadDocument): Promise<any> {
    const data = new FormData();
    data.append('transactionId', reqBody.transactionId);
    if (reqBody.appointmentIds) {
      data.append('appointmentIds', reqBody.appointmentIds);
    }
    if (reqBody.details) {
      data.append('details', reqBody.details);
    }
    reqBody.files.forEach((file) => {
      data.append('files', file);
    });
    if (reqBody.subType) data.append('subType', reqBody.subType);

    return APIService.post(ApiEndpoint.uploadDocument, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        const progress = Math.floor((loaded * 100) / total);
        if (progress < 100) emitUploadFileEvent(progress);
        // Update state here
      },
    }).then(() => {
      emitUploadFileEvent(100);
    });
  }

  static downloadTransactionDocument(reqBody: IGetDocument): Promise<AxiosResponse<any>[]> {
    return APIService.post(ApiEndpoint.downloadDocument, reqBody);
  }

  static getTransactionDocument(reqBody: IGetDocument): Promise<AxiosResponse<any>[]> {
    return APIService.post(ApiEndpoint.getDocument, reqBody);
  }
}
